export default {
    computed: {
        clientId() { return this.$route.params.clientId; },
        parentClientId() { return this.$store.state.parentClientId },
        isLoading() { return this.$store.state.isLoading; },
        isSubmitLoading() { return this.$store.state.isSubmitLoading; },
        isError() { return this.$store.state.isError; },
        isTimePassed() { return this.$store.state.isTimePassed; },
        isWalkin() { return this.$store.state.isWalkin; },
        isOnline() { return this.$store.state.isOnline; },
        showGlassbreak() { return this.$store.state.showGlassbreak; },
        showInstructions() { return this.$store.state.showInstructions; },
        showFailedAttempts() { return this.$store.state.showOnlineFailedAttempts },
        currentModel() { return this.$store.state.currentModel; },
        currentStep() { return this.$store.state.currentStep; },
        inputFocused() { return this.$store.state.inputFocus; },
        showPtt() {
            return this.currentModel.settings.showTreatmentTime
                && this.currentModel.availableTime
                && this.currentModel.availableTime.actualAvailableTimeDisplay;
        }
    },
    methods: {
        backToLobby() {
            this.$store.dispatch('unLock');
            if (this.parentClientId) {
                this.$store.dispatch('resetWalkinForm');
                this.$router.push({ name: 'lobby_root', params: { clientId: this.parentClientId } });
            }
            else {
                this.$store.dispatch('resetWalkinForm', this.clientId);
                this.$router.push({ name: 'lobby_root', params: { clientId: this.clientId } });
            }
            this.$store.state.showGlassbreak = false;
            this.$store.state.showOnlineFailedAttempts = false;
            this.$store.state.onlineFailedAttempts = 0;
            this.$store.state.currentStep = 0;
            this.$store.state.isWalkin = false;
            this.$store.state.isOnline = false;
        },
        unmask(maskedValue, mask) {
            if (!maskedValue || !maskedValue.length)
                return '';
            let defaultTokens = ['#', 'X', 'S', 'A', 'a', '!'];
            let unmaskedValue = '';
            let isToken;

            for (let i = 0; i < maskedValue.length; i++) {
                isToken = false;
                for (let j = 0; j < defaultTokens.length; j++) {
                    if (mask[i] == defaultTokens[j]) {
                        isToken = true;
                    }
                }

                if (isToken) {
                    unmaskedValue += maskedValue[i];
                }
            }

            return unmaskedValue;
        },
        isMobile() {
            var hasTouchScreen = false;
            if ("maxTouchPoints" in navigator) {
                hasTouchScreen = navigator.maxTouchPoints > 0;
            } else if ("msMaxTouchPoints" in navigator) {
                hasTouchScreen = navigator.msMaxTouchPoints > 0;
            } else {
                var mQ = window.matchMedia && matchMedia("(pointer:coarse)");
                if (mQ && mQ.media === "(pointer:coarse)") {
                    hasTouchScreen = !!mQ.matches;
                } else if ('orientation' in window) {
                    hasTouchScreen = true; // deprecated, but good fallback
                } else {
                    // Only as a last resort, fall back to user agent sniffing
                    var UA = navigator.userAgent;
                    hasTouchScreen = (
                        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
                    );
                }
            }
            return hasTouchScreen;
        },
        isClosedTime() {
            if (!this.currentModel
                || !this.currentModel.settings.clientHours
                || !this.currentModel.settings.clientHours.filter(x => !!x.closedTime))
                return false;
            const today = new Date();
            const day = this.getDayOfWeek(today.getDay());
            const clientHoursToday = this.currentModel.settings.clientHours.filter(x => x.dayName === day);
            if (!clientHoursToday || !clientHoursToday[0] || !clientHoursToday[0].closeTime)
                return false;

            //let isClientClosed = true;
            for (let i = 0; i < clientHoursToday.length; i++) {
                let closeTime = clientHoursToday[i].closeTime;
                let preOpenTime = clientHoursToday[i].preOpenTime;

                let closeTimeDate = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate(),
                    closeTime.hours,
                    closeTime.minutes);

                let preOpenTimeDate = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate(),
                    preOpenTime.hours,
                    preOpenTime.minutes);

                if (preOpenTimeDate <= today && today <= closeTimeDate) return false;
                //isClientClosed = isClientClosed && (today > closeTimeDate);
            }
            return true;
        },
        isPreOpenTime() {
            if (!this.currentModel
                || !this.currentModel.settings.clientHours
                || !this.currentModel.settings.clientHours.filter(x => !!x.preOpenTime))
                return false;
            const today = new Date();
            const day = this.getDayOfWeek(today.getDay());
            const clientHoursToday = this.currentModel.settings.clientHours.filter(x => x.dayName === day);
            if (!clientHoursToday || !clientHoursToday[0] || !clientHoursToday[0].preOpenTime)
                return false;

            let isClientNotOpened = true;
            for (let i = 0; i < clientHoursToday.length; i++) {
                let preOpenTime = clientHoursToday[i].preOpenTime;
                let preOpenDate = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate(),
                    preOpenTime.hours,
                    preOpenTime.minutes);

                isClientNotOpened = isClientNotOpened && (today < preOpenDate);
            }
            return isClientNotOpened;
        },
        isSpecialEvent() {
            if (!this.currentModel || !this.currentModel.settings.specialEvents)
                return false;

            const allDay = this.currentModel.settings.specialEvents.filter(x => x.closeAllDay);

            if (allDay.length) {
                return allDay[0].eventMessage;
            }

            const partialDay = this.currentModel.settings.specialEvents.filter(x => !x.closeAllDay);
            if (!partialDay.length) return false;
            const today = new Date();
            const day = this.getDayOfWeek(today.getDay());
            const clientHoursToday = this.currentModel.settings.clientHours.filter(x => x.dayName === day);
            let clientCloseTimeDate = new Date();
            if (clientHoursToday && clientHoursToday[0] && clientHoursToday[0].closeTime) {
                const clientCloseTime = clientHoursToday[0].closeTime;
                clientCloseTimeDate = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate(),
                    clientCloseTime.hours,
                    clientCloseTime.minutes);
            }

            const openDate = new Date(Date.parse(partialDay[0].openTime));
            const closeDate = new Date(Date.parse(partialDay[0].closeTime));
            const openTime = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                openDate.getHours(),
                openDate.getMinutes());
            const closeTime = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                closeDate.getHours(),
                closeDate.getMinutes());

            return clientCloseTimeDate === closeTime || (today > openTime && today < closeTime) ? partialDay[0].eventMessage : false;
            
        },
        getDayOfWeek(day) {
            switch (day) {
                case 0:
                    return 'Sunday';
                case 1:
                    return 'Monday';
                case 2:
                    return 'Tuesday';
                case 3:
                    return 'Wednesday';
                case 4:
                    return 'Thursday';
                case 5:
                    return 'Friday';
                case 6:
                    return 'Saturday';
                default:
                    return null;
            }
        }
    }
}